export const CALENDAR_COLORS = {
  blue: '#6BA4B8',
  black: '#1a1a1a',
  black90: '#414042',
  mediumGrey: '#808080',
  white: '#ffffff',
  // dark gray / accent used by the Legends calendars instead of the default blue
  legendsDarkGray: '#404041',
  legendsAccent: '#b69a52',
};

// Display name for CALENDAR_COLORS.blue, embedded in the print calendar PDF's
// custom metadata as a production color reference for the print vendor.
export const CALENDAR_COLOR_NAMES = {
  blue: 'Goodman Blue',
};

/**
 * Site IDs that use the Legends dark-gray calendar theme instead of the default
 * blue. Covers Legends on Lake Lorraine (incl. Pearl Garden/Essence, Fitness,
 * Fitness Center, Break Room) and Legends of Sarasota.
 *
 * The calendar PDF doesn't support real theming yet, so the theme is matched by
 * site id. Keep this list as the single source of truth — it is referenced by
 * both pdf.service.ts (theme + grid lines) and calendar.service.ts (header fill).
 */
export const LEGENDS_DARK_GRAY_SITE_IDS = new Set<number>([
  137, 138, 147, 148, 149, 172, 173, 177,
]);

/** Whether the given site uses the Legends dark-gray calendar theme. */
export const usesLegendsDarkGrayTheme = (siteId?: number): boolean =>
  !!siteId && LEGENDS_DARK_GRAY_SITE_IDS.has(siteId);
